import * as clipboard from "app/core/components/dashboard/d3/clipboard"
import { SvgEventHandlers } from "app/core/components/dashboard/d3/events/types"

export const register = (handlers?: SvgEventHandlers, editable?: boolean) => {
  const onPaste = async (event: ClipboardEvent) => {
    // don't allow paste from the app menu on non-editable screens
    if (editable) {
      const domHasChanged = await clipboard.paste(event)
      handlers?.paste?.(domHasChanged, event)
    }
  }
  // paste using a keyboard shortcut is handled in keyboard event handlers
  // paste from the context menu is handled from in context menu handlers
  // this handler is only for paste triggered from the app menu
  document.addEventListener("paste", onPaste)
  return () => {
    document.removeEventListener("paste", onPaste)
  }
}
